/*
 * Opens any link to calendly.com in Calendly's popup widget.
 * The widget script and stylesheet load on first click only, so pages carry no
 * Calendly weight until a visitor asks to book. Without JS the link still works.
 */
(() => {
  const BASE = 'https://assets.calendly.com/assets/external/widget';
  let loading;

  const loadWidget = () => {
    if (window.Calendly) return Promise.resolve();
    if (loading) return loading;
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = `${BASE}.css`;
    document.head.append(css);
    loading = new Promise((resolve, reject) => {
      const js = document.createElement('script');
      js.src = `${BASE}.js`;
      js.async = true;
      js.onload = resolve;
      js.onerror = reject;
      document.head.append(js);
    });
    return loading;
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const link = event.target.closest('a[href*="calendly.com/"]');
    if (!link) return;
    event.preventDefault();
    loadWidget()
      .then(() => window.Calendly.initPopupWidget({ url: link.href }))
      .catch(() => window.open(link.href, '_blank', 'noopener'));
  });
})();
